import Head from 'next/head';

import Topic from 'components/Topic';
import Facebook from 'components/Facebook';
import VoteUs from 'components/VoteUs';

function Site() {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta
          name="description"
          content="Volte č. 3! Jsme sdružení nezávislých kandidátů pro obce Vysoký Újezd, Kozolupy a Kuchař."
        />
        <meta property="og:locale" content="cs-CZ" />
        <meta property="og:site_name" content="ŽIJME SPOLEČNĚ" />
        <meta property="og:title" content="ŽIJME SPOLEČNĚ" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.zijmespolecne.cz/" />
        <meta property="og:image" content="https://www.zijmespolecne.cz/img/zs.jpg" />
        <meta
          property="og:description"
          content="Volte č. 3! Jsme sdružení nezávislých kandidátů pro obce Vysoký Újezd, Kozolupy a Kuchař."
        />
        <title>ŽIJME SPOLEČNĚ</title>
      </Head>
      <div>
        <div className="mt-4 mb-8 md:my-10 mx-auto md:max-w-7xl px-4 md:px-16">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 md:gap-16">
            <img src="/img/logo.png" alt="Žijme společně" className="w-24 md:w-32 mx-auto" />
            <h1 className="text-xl md:text-2xl tracking-normal text-center md:text-left text-blue-900">
              Bydlíme společně v obcích Vysoký Újezd, Kozolupy a Kuchař, které se díky dobré dopravní dostupnosti a
              blízkosti Prahy staly oblíbenou lokalitou pro všechny z nás. Rádi bychom, aby se náš společný prostor stal
              příjemným místem k rozvoji našich životů i životů našich dětí. <strong>Volte č. 3!</strong>
            </h1>
          </div>
        </div>
        <div className="relative md:max-w-7xl mx-auto mb-8 md:mb-32">
          <img
            src="/img/zijme-spolecne-cover.jpg"
            alt="Žijme společně"
            className="w-full md:shadow-xl object-cover h-64 md:h-auto"
          />
          <p className="bg-white md:shadow-2xl text-md md:text-xl md:p-6 md:absolute left-24 right-24 -bottom-20 m-4 md:m-0">
            Není jednoduché sladit zájmy lidí ze tří rozdílných obcí, zájmy starousedlíků a nově přistěhovalých. Každý z
            nás pochází z jiných poměrů a nachází se v jiné životní etapě, tím jsou dány i naše rozdílné priority.
            Snažme se naslouchat druhým, pochopit jejich názory a především dělat kompromisy.
          </p>
          <p className="md:absolute font-oswald leading-tight md:top-11 md:right-11 xl:-top-16 xl:-right-16 text-2xl font-black bg-red-700 h-16 md:h-32 w-32 mx-auto md:mx-0 md:w-32 rounded-full text-center flex items-center justify-center text-white">
            Volte
            <br className="hidden md:block" /> č. 3
          </p>
        </div>
        <main className="mb-8 md:mb-24 md:mt-12 mx-auto max-w-7xl px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:my-16">
            <div className="flex flex-col gap-6 text-gray-500">
              <h2 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl text-blue-900">
                Naše obce <em className="text-red-700">společně</em>
              </h2>
              <p>
                Chápeme, že každá z našich obcí je jiná, má jinou historii, jiné problémy a jiné priority. Nechceme
                však, aby naše obce byly rozděleny a žily si svým vlastním životem. Naším cílem je obce propojit nejen
                infrastrukturně (pěšími cestami, cyklostezkami, častějším autobusovým spojením), kulturně, ale i lidsky
                a komunikačně tak, abychom se mohli více poznat a žili v nich opravdu společně. Důležité je naslouchat
                všem názorům a přáním a dělat rozhodnutí prospěšná pro všechny. Propojení musí být proto citlivé, se
                zachováním určité autonomie.
              </p>
              <p>
                Vytvořme silný svazek tří obcí, který bude mít v našem mikroregionu rozhodující vliv. Snažme se spojit a
                spolupracovat i s dalšími okolními obcemi na společných projektech, kterými může být například
                devítiletá základní škola nebo lepší dopravní propojení s Prahou.
              </p>
            </div>
            <div className="flex flex-col gap-6 text-gray-500">
              <h2 className="text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl text-blue-900">
                Lépe <em className="text-red-700">společně</em>
              </h2>
              <p>
                Jsme nestranní a nezávislí, nezatížení minulostí, nezatížení spory. Nechceme rozdělovat, ale být
                propojovacím článkem mezi všemi obyvateli našich obcí. Chceme podporovat dobré věci a projekty, ať už
                vzejdou od kohokoli. Chceme se podílet na rozhodování v obci, být konstruktivní a diskutovat o
                problémech. Naše sdružení nezávislých kandidátů není jen účelové seskupení před volbami. Společně chceme
                všichni spolupracovat i celé volební období, a vytvořit tak silný hlas do dalších let. Jsme každý
                odborníkem ve svém oboru a své znalosti využijeme ve prospěch nás všech.
              </p>
              <p>
                Vnímáme věci, které nás všechny trápí. V několika následujících tématech Vám představíme myšlenky, které
                bychom rádi dostali do společné i veřejné diskuse.
              </p>
              <p>Nejdříve bychom se Vám ale rádi představili…</p>
            </div>
          </div>
          <Facebook />
        </main>

        <Topic
          color="light"
          subtitle="1. Téma"
          title={
            <>
              Plánujme a stavme <em>společně</em>
            </>
          }
          person={{
            name: 'Josef Jáchim, DiS.',
            photo: '/img/faces/josef-jachim.jpg',
            about: 'obor pozemní stavby, technický ředitel, projektant vytápění a chlazení',
            position: 'náš specialista na výstavbu, energie a urbanismus',
            quote:
              'Před sedmi lety jsme, nyní již s mou manželkou Danou, začali náš společný život v nově budované lokalitě Za Hospodou. Již od začátku jsme se zde cítili dobře, a to nejen kvůli krásnému okolí, ale hlavně díky místním lidem, kteří nás  s otevřenou náručí přijali mezi sebe. Bylo tak snadné zapojit se do společenského života v naší obci a pomoci pozvednout pomalu zanikající tradice. Právě díky různým dětským akcím a též i místní mateřské škole získaly naše dvě dcery Juliana a Mína, které se nám mezitím narodily, řadu kamarádů, ale i zážitků, jež si ponesou životem. Chtěli bychom, aby všichni nově přistěhovalí a jejich děti mohli zažívat to, co my. Rád přispěji svými znalostmi z oboru stavebnictví i energetiky, pracovitostí a cílevědomostí k tomu, aby se nám všem v našich obcích žilo společně lépe. K tomu však potřebujeme vybudovat a rozšířit tolik chybějící infrastrukturu a občanskou vybavenost.',
          }}
          perex={
            <p>
              Výrazný nárůst počtu obyvatel s sebou nese jak pozitiva, tak negativa. Co nás všechny nejvíce trápí, je
              nedostatečná infrastruktura a občanská vybavenost našich obcí. Původní developerská výstavba bohužel
              nebyla těmito aspekty podmíněna tak, jak tomu dnes běžně u developerských projektů bývá. Nejsme pro další
              změny územního plánu vedoucí k rozšiřování stavebních pozemků, ale spíše pro obytnou a smíšenou výstavbu
              uvnitř intravilánu. Veškeré další developerské projekty chceme podmínit investicemi do důležitých projektů
              v našich obcích.
            </p>
          }
        >
          <p>
            Výrazný nárůst počtu obyvatel s sebou nese jak pozitiva, tak negativa. Co nás všechny nejvíce trápí, je
            nedostatečná infrastruktura a občanská vybavenost našich obcí. Původní developerská výstavba bohužel nebyla
            těmito aspekty podmíněna tak, jak tomu dnes běžně u developerských projektů bývá. Nejsme pro další změny
            územního plánu vedoucí k rozšiřování stavebních pozemků, ale spíše pro obytnou a smíšenou výstavbu uvnitř
            intravilánu. Veškeré další developerské projekty chceme podmínit investicemi do důležitých projektů v našich
            obcích.
          </p>
          <p>
            Každou z našich obcí trápí jiný problém. Někde jsou to chybějící hřiště i prostory pro setkávání, nekvalitní
            voda a její nedostatek, jinde zase absence chodníků nebo prašné cesty místo asfaltových. Náves s vodní
            plochou, která leží v každé naší obci, je místem pro setkávání a relaxaci. Aby tato místa plnila svou funkci
            a zároveň vizuálně pozvedla naše obce, je potřeba je zkultivovat a revitalizovat. Budeme naslouchat každému
            z Vás a dáme Vám možnost vyjádřit svůj názor na nově vytvořené otevřené platformě obce, díky čemuž budete
            moci ovlivňovat rozhodnutí, do kterého projektu se bude prioritně investovat.
          </p>
          <p>
            Pokud chceme něčeho dosáhnout, bez dobrého plánování to nepůjde. Dnes se k nám stěhuje velké množství
            mladých rodin, a proto akutně potřebujeme zvětšit kapacitu mateřské a základní školy, o což se zásadně
            zasazuje již současné vedení obce. Časem nám však děti odrostou a my zestárneme. Pak nám bude chybět
            lékařské středisko a dům s pečovatelskou službou. Nesmíme čekat, až nějaký problém nastane, ale řešit ho s
            dlouhodobou vizí a tomu odpovídající přípravou.
          </p>
          <p>
            Víme, že střednědobé a dlouhodobé plánování je důležité pro rozvoj našich obcí. Chceme přehodnotit nebo
            dokončit stávající projekty, vytvořit plán s přesahem do dalších desetiletí, lépe plánovat financování a
            využívání dotací k rozjetí více projektů současně, mít vždy „v šuplíku“ připravený projekt a vytáhnout ho ve
            správnou dobu tak, aby realizace časově navazovala na vypsané dotace.
          </p>
        </Topic>

        <Topic
          color="white"
          subtitle="2. Téma"
          title={
            <>
              Pro naše děti <em>společně</em>
            </>
          }
          person={{
            name: 'Bc. Lucia Mráčková',
            photo: '/img/faces/lucia-mrackova.jpg',
            about: 'manažerka v bankovnictví, zakladatelka dětského klubu “Újezďáček”, učitelka v mateřské škole',
            position: 'naše specialistka na školství a pedagogiku',
            quote:
              'Do Vysokého Újezdu jsem se před více než sedmi lety doslova zamilovala na první pohled. Je nejenom mým domovem, domovem mé rodiny, ale i místem, ke kterému se vážou nejkrásnější vzpomínky mého života. V době rodičovské dovolené jsem založila a vedu místní Klubíčko (cvičení s nejmenšími dětmi) a ve spolupráci s obcí i Újezďáček (dětské centrum pro maminky s dětmi). Jako máma dvou dětí vnímám aktuální tíživou situaci se školkou, školou a také nedostatečnou dopravní bezpečnost našich obcí. Před rodičovskou dovolenou jsem řadu let pracovala v bankovním sektoru, kde jsem nasbírala mnoho užitečných zkušeností ze světa financí, které jsou v dnešním světě investic a úvěrů velmi důležité i z pohledu obce. Chtěla bych se stát i Vaším hlasem, naslouchat Vám, pomáhat, ještě víc zlepšovat život v našich obcích tak, aby se nám, potažmo našim dětem, zde dobře žilo…',
          }}
          perex={
            <p>
              Děti jsou naše budoucnost. Jejich uvážená výchova a vedení k pohybu, kultuře a komunikaci se nám
              mnohonásobně vrátí. Dnes se k nám stěhuje velké množství mladých rodin, které zjišťují, že jim chybí
              základní občanská vybavenost. Chceme spojovat nejen nás dospělé, ale hlavně naše děti. Co k tomu
              potřebujeme? Novou mateřskou a základní devítiletou školu, která bude kapacitně schopna pojmout naše děti,
              a my je tak nebudeme muset rozvážet po okolních obcích, popř. Praze. Naše děti tak budou moci dostat
              kvalitní vzdělání spojené s možností tvorby nenahraditelných sociálních vazeb zasahujících i do jejich
              mimoškolního života formou vzájemného setkávání.
            </p>
          }
        >
          <p>
            Děti jsou naše budoucnost. Jejich uvážená výchova a vedení k pohybu, kultuře a komunikaci se nám
            mnohonásobně vrátí. Dnes se k nám stěhuje velké množství mladých rodin, které zjišťují, že jim chybí
            základní občanská vybavenost. Chceme spojovat nejen nás dospělé, ale hlavně naše děti. Co k tomu
            potřebujeme? Novou mateřskou a základní devítiletou školu, která bude kapacitně schopna pojmout naše děti, a
            my je tak nebudeme muset rozvážet po okolních obcích, popř. Praze. Naše děti tak budou moci dostat kvalitní
            vzdělání spojené s možností tvorby nenahraditelných sociálních vazeb zasahujících i do jejich mimoškolního
            života formou vzájemného setkávání.
          </p>
          <p>
            Již v současné době je problém umístit děti, které ukončí první stupeň ve zdejší základní škole, do okolních
            devítiletých škol. Proto je nutné zajistit výstavbu devítileté základní školy pro naše obce, potažmo náš
            mikroregion, v co nejkratší době. Do doby výstavby nové školy musíme co nejvíce spolupracovat s devítiletými
            školami v okolních obcích i městech a zajistit našim dětem dopravně dostupnou povinnou školní docházku. S
            tím samozřejmě souvisí posílení a vybudování nových spojů veřejné dopravy.
          </p>
          <p>
            S projekty nové základní a mateřské školy je třeba myslet i na zvýšení dopravní bezpečnosti v okolí školy,
            odstranění rizikových míst na cestě do školy a celkově zlepšení podmínek pro děti dopravující se do škol
            pěšky, na kole anebo veřejnou dopravou.
          </p>
          <p>
            Ukázalo se, že je v obcích potřeba vytvořit i prostor pro rodiče s nejmenšími dětmi, kde by se mohli
            setkávat a také místa, kde by si naše děti mohly hrát, provozovat mimoškolní aktivity nebo zájmové kroužky.
          </p>
        </Topic>

        <Topic
          color="light"
          subtitle="3. Téma"
          title={
            <>
              Dotace a financování <em>společně</em>
            </>
          }
          person={{
            name: 'Ing. Martin Švolba',
            photo: '/img/faces/martin-svolba.jpg',
            about:
              'ekonom se zaměřením na finanční management, ředitel odboru Výzkumu, Vývoje a Inovací na Ministerstvu průmyslu a obchodu ČR',
            position: 'náš expert na podnikání, dotace a financování',
            quote:
              'Pocházím z malé vesnice poblíž Rakovníka a myslím, že mám tedy představu o potřebách i možnostech menších obcí. Zároveň již více než 10 let pracuji na ministerstvech (nejdříve 5 let na Ministerstvu životního prostředí, poté na Ministerstvu průmyslu a obchodu). Můj tým na ministerstvu připravil a zpracoval velké množství dotačních titulů pro obce i podnikatele v rozsahu miliard korun. Mám tedy zároveň představu o příležitostech a úskalích, které dotační politika přináší. Rád bych své zkušenosti, schopnosti i nabyté kontakty využil ve prospěch a rozvoj našich obcí, kde jsme s manželkou vytvořili nový domov pro nás a naše děti.',
          }}
          perex={
            <p>
              Dotace pro obce jsou v dnešní době zcela zásadním zdrojem financí pro rozvoj a investice. Dotační
              “džungle” však stále houstne a je třeba se aktivně snažit, abychom se v ní neztratili, našli v ní správnou
              cestu a plně využili, co nabízí.
            </p>
          }
        >
          <p>
            Dotace pro obce jsou v dnešní době zcela zásadním zdrojem financí pro rozvoj a investice. Dotační “džungle”
            však stále houstne a je třeba se aktivně snažit, abychom se v ní neztratili, našli v ní správnou cestu a
            plně využili, co nabízí.
          </p>
          <p>Důležité je:</p>
          <ul className="space-y-4 ml-4">
            <li className="list-disc">
              <p>
                Zaměřit krátkodobý, střednědobý i dlouhodobý rozvojový a investiční plán obce na veškeré dostupné dotace
                poskytované jak z národních, tak z evropských zdrojů. Nelze čekat a reagovat až na vyhlášení výzvy.
                Harmonogram investic by měl pružně reagovat na možnosti podpory a přizpůsobovat se aktuálním možnostem
                financování.
              </p>
            </li>
            <li className="list-disc">
              <p>
                Průběžně připravovat dokumentaci potřebnou pro dotace. Chceme zainvestovat prostředky do studií,
                projektů a dokumentací k investicím, o kterých jsme přesvědčeni, že jsou nezbytné. Nepřipravenost může
                odložit realizaci projektu o roky a způsobí tím diskomfort obyvatel. V konečném důsledku pak realizace
                zabere více finančních prostředků a nese s sebou vyšší pravděpodobnost neúspěchu získání dotací
                vynecháním podání žádosti v předešlých kolech.
              </p>
            </li>
            <li className="list-disc">
              <p>
                Mít zajištěné prostředky na vlastní kofinancování a aktivně řídit cash flow. Nelze čekat na vypořádání
                jedné dotace, splacení celého úvěru či dostatečné finanční úspory a až poté začít uvažovat o další
                investici. Je třeba aktivně řídit finanční toky a tím urychlit realizace investic.
              </p>
            </li>
            <li className="list-disc">
              <p>
                Mít zajištěnou kvalitní administraci dotací, ať již interními kapacitami obecního úřadu, či externí
                spoluprací s odborníky. Nejsložitější na dotaci není ji získat, ale neudělat v průběhu zbytečné chyby,
                které následně způsobují nemalé problémy popřípadě zdržení realizace projektu.
              </p>
            </li>
          </ul>
        </Topic>

        <Topic
          color="white"
          subtitle="4. Téma"
          title={
            <>
              Dýchejme <em>společně</em>
            </>
          }
          person={{
            name: 'Mgr. Jaroslav Kepka',
            photo: '/img/faces/jaroslav-kepka.jpg',
            about: 'politolog, vedoucí oddělení politiky a strategií na Ministerstvu životního prostředí',
            position: 'náš odborník na životní prostředí a dotace',
            quote:
              'Narodil jsem se v Rokycanech. Do obce jsme se s manželkou Martinou a dvěma syny přistěhovali v roce 2020, tedy v hluboké době covidové. I přes to jsme se snažili, co nejdříve vnímat potřeby a názory staro a novousedlíků. Poloha našich obcí nemá konkurenci, blízkost Prahy na jedné straně a CHKO Český kras na straně druhé je skvělým předpokladem pro dobrou kvalitu života místních obyvatel. Nejhorším scénářem je, že se naše obce stanou, s dalším rozšiřováním, anonymním satelitem Prahy. Rád bych pomohl rozvoji našich obcí přípravou žádostí o národní či evropské dotace v oblasti komunitní energetiky, podpory adaptačních opatření (zadržení vody v krajině, využití zelených ploch, výsadba stromů), odpadového hospodářství nebo podpory kombinace různých druhů dopravy. Mým cílem je také zapojení co nejvíce obyvatel do dění v našich obcích a s tím související rozvoj tradičních kulturních akcí.',
          }}
          perex={
            <p>
              Kvalitní životní prostředí je základním předpokladem pro kvalitní život. Nástroje k jeho zachování a
              odpovědnost za něj neleží pouze na úrovni státu nebo kraje, ale zejména na úrovni měst a obcí. Podporujeme
              dokončení připravované studie zeleně i s ohledem na finanční náročnost údržby zelených ploch.
            </p>
          }
        >
          <p>
            Kvalitní životní prostředí je základním předpokladem pro kvalitní život. Nástroje k jeho zachování a
            odpovědnost za něj neleží pouze na úrovni státu nebo kraje, ale zejména na úrovni měst a obcí. Podporujeme
            dokončení připravované studie zeleně i s ohledem na finanční náročnost údržby zelených ploch.
          </p>
          <p>
            Zelené plochy a zachování vody v krajině jsou důležitými faktory pro zlepšení místního mikroklimatu -
            zejména v horkých letních měsících. Tato místa poskytují také vhodné prostředí pro setkávání obyvatel,
            společné „grilovačky“, popř. mohou sloužit jako hřiště pro děti. Rádi bychom zapojili co nejvíce lidí, kteří
            mají čas a chuť, do úpravy okolí a společných ploch.
          </p>
          <p>
            Chtěli bychom zrevidovat odpadovou politiku obce s důrazem na motivaci k třídění odpadů, zvýšení frekvence
            vývozu kontejnerů, navýšení počtu odpadkových košů zejména v místech venčení psů, prověření aktuální
            efektivnosti svozu odpadů či zvážení pořízení/postavení? vlastní kompostárny a podpora dobrovolných
            komunitních akcí typu “Ukliďme Česko”.
          </p>
          <p>
            V rámci výstavby financované developery se chceme zaměřit na environmentální aspekt nových budov či
            veřejného osvětlení. Bohužel i zdánlivě jednoduché a samozřejmé věci, jako je veřejné osvětlení s teplou
            oranžovou barvou spektra, která je méně zdraví škodlivá, návrhy staveb, kde se počítá s umístěním
            fotovoltaických panelů osazení na střechách budov či využití srážkových vod, nebyly ze strany developerů
            vůbec řešeny.
          </p>
          <p>
            Na mnoho z výše uvedených aktivit je možné využít národní či evropské zdroje. Právě v oblasti dotací máme
            velké zkušenosti, které rádi zužitkujeme k rychlejšímu rozvoji a zlepšení životního prostředí v našich
            obcích.
          </p>
        </Topic>

        <Topic
          color="light"
          subtitle="5. Téma"
          title={
            <>
              Za kulturou a sportem <em>společně</em>
            </>
          }
          person={{
            name: 'Bc. Andrea Čadová',
            photo: '/img/faces/andrea-cadova.jpg',
            about: 'speciální pedagogika, sociální pracovník v pečovatelské službě',
            position: 'naše organizátorka kulturních a dětských akcí',
            quote:
              'V obci Vysoký Újezd žiji téměř celý život, mám tedy k místu silné pouto. Od dětství jsem byla součástí akcí, které byly v našich obcích pořádány, nejprve jako jejich účastník a později jsem se společně s dalšími zapojila i do jejich příprav. V průběhu všech let, co zde žiji, jsem byla svědkem výrazné přeměny obce. Přátele mám mezi starousedlíky i novousedlíky. Vystudovala jsem speciální pedagogiku, věnuji se tématům vzdělávání a sociální péče. Zároveň mám dlouholeté pracovní zkušenosti z městského úřadu jedné z částí v Praze. Mým přáním je, abych nejen já, můj partner a naše dcery, ale i všichni, co zde žijí, naši obec vnímali jako svůj domov. Domov, ve kterém je srdečná atmosféra, kde máme spousty přátel a kamarádů a kam se vždy budeme rádi vracet.',
          }}
          perex={
            <p>
              Chceme nejen stavět chodníky, opravovat komunikace, ale chceme i vytvořit obec, která nebude jen místem
              pro přespávání, nýbrž skutečným domovem. V souvislosti s rozvojem moderních technologií a rostoucí úlohou
              sociálních sítí se v průběhu posledních let významně změnily způsoby, jak člověk tráví svůj volný čas.
              Spousta z nás tráví hodně času vsedě v práci a naše děti pak ve škole. I přesto není jednoduché je ve
              volném čase odtrhnout od monitoru počítače nebo displeje mobilního telefonu a motivovat k aktivnímu
              trávení volného času. Pohyb je cestou ke zdravému tělu i duchu. Reagujme tak na měnící se potřeby a
              požadavky obyvatel na sportovní vybavenost a poskytování související služeb.
            </p>
          }
        >
          <p>
            Chceme nejen stavět chodníky, opravovat komunikace, ale chceme i vytvořit obec, která nebude jen místem pro
            přespávání, nýbrž skutečným domovem. V souvislosti s rozvojem moderních technologií a rostoucí úlohou
            sociálních sítí se v průběhu posledních let významně změnily způsoby, jak člověk tráví svůj volný čas.
            Spousta z nás tráví hodně času vsedě v práci a naše děti pak ve škole. I přesto není jednoduché je ve volném
            čase odtrhnout od monitoru počítače nebo displeje mobilního telefonu a motivovat k aktivnímu trávení volného
            času. Pohyb je cestou ke zdravému tělu i duchu. Reagujme tak na měnící se potřeby a požadavky obyvatel na
            sportovní vybavenost a poskytování související služeb.
          </p>
          <p>
            Založením kulturního výboru chceme podpořit aktivní trávení volného času - komunitní aktivity i sportovní
            činnosti. Kulturní výbor je komise, jež oceňuje a podporuje činnost občanů, kteří mají chuť a zájem
            organizovat nejrůznější akce pro druhé. Budeme dbát na uchování tradic i mezigenerační propojení a
            podporovat spolupráci s jednotlivými spolky nebo organizacemi v našich obcích.
          </p>
          <p>
            Důležitá je pro nás údržba sportovních zařízení ve vlastnictví obce i podpora údržby sportovních zařízení ve
            vlastnictví spolků či organizací a jejich případná modernizace v souladu s potřebami obcí a obyvatel. Neméně
            důležitá je i podpora rozvoje nových venkovních sportovišť určených všem věkovým skupinám našich obyvatel.
          </p>
        </Topic>

        <Topic
          color="white"
          subtitle="6. Téma"
          title={
            <>
              Povídejme si <em>společně</em>
            </>
          }
          person={{
            name: 'David Šmehlík',
            photo: '/img/faces/david-smehlik.jpg',
            about: 'technický ředitel a spolumajitel vývojářského studia, odborník na online marketing',
            position: 'náš specialista na online komunikaci a digitalizaci',
            quote:
              'Narodil jsem se v Praze, kde jsem strávil většinu svého dosavadního života. Když jsme s manželkou Veronikou hledali místo pro život naší rodiny, okouzlilo nás prostředí Vysokého Újezdu, jeho historie i život obce, která byla jen pár kilometrů od našeho tehdejšího bydliště. Jakožto kluk od počítačů jsem strávil velkou část svého pracovního života za monitorem. Založil jsem jednu z prvních specializovaných social media agentur v ČR, což mě naučilo mnoho o tom, jak citlivá je volba slov a vět, kterými se snažíte sdělit to, co máte na srdci. Mám tříletou dceru Emu, pro kterou bych chtěl v budoucnu z našich obcí udělat místo, ze kterého nebude mít důvod utíkat za bydlením do Prahy. Přál bych si, aby jí nová infrastruktura našich obcí dovolila pohodlně se po práci nebo zábavě dopravit domů.',
          }}
          perex={
            <p>
              Věcná a srozumitelná komunikace je základem dobrých vztahů. Pokud se věci neříkají přímo a pochopitelně,
              může to vést k nedorozuměním a ke zkreslení informací, které se pak dokáží rychle šířit. Rádi bychom
              zlepšili komunikaci ze strany obecního úřadu směrem k nám, obyvatelům našich obcí, a zároveň podporovali
              vznik společných komunikačních kanálů, kde bychom se mohli lépe ptát a rychleji dostávat odpovědi na
              otázky, které nás trápí.
            </p>
          }
        >
          <p>
            Věcná a srozumitelná komunikace je základem dobrých vztahů. Pokud se věci neříkají přímo a pochopitelně,
            může to vést k nedorozuměním a ke zkreslení informací, které se pak dokáží rychle šířit. Rádi bychom
            zlepšili komunikaci ze strany obecního úřadu směrem k nám, obyvatelům našich obcí, a zároveň podporovali
            vznik společných komunikačních kanálů, kde bychom se mohli lépe ptát a rychleji dostávat odpovědi na otázky,
            které nás trápí.
          </p>
          <p>
            Žijeme ve 21. století a nebojíme se moderních technologií. Na Facebooku jsme jako doma, WhatsApp, Telegram,
            diskuzní fóra, Google Forms, … Chceme, abychom si mohli povídat společně o tom, co je pro nás podstatné.
          </p>
          <p>
            Důležitá je i komunikace obce s krajskými a státními úřady, stejně jako s okolními obcemi. S tím souvisí i
            lepší a přehlednější prezentace obce nejen formou webových stránek. Důležité je i zjednodušení obecní
            agendy, směrem k nám obyvatelům, její postupnou digitalizací.
          </p>
        </Topic>

        <Topic
          color="light"
          subtitle="7. Téma"
          title={
            <>
              Podpořme <em>společně</em> podnikatele
            </>
          }
          person={{
            name: 'Ing. Tomáš Kunc',
            photo: '/img/faces/tomas-kunc.jpg',
            about: 'ekonom, finanční ředitel',
            position: 'náš specialista na rozpočty a řízení projektů',
            quote:
              'Se ženou a třemi dětmi jsme se v roce 2020 přestěhovali ze Zličína do Vysokého Újezdu. Oba jsme v dětství žili na vesnici a cítili jsme, že chceme vychovávat naše děti v menší komunitě lidí. Vysoký Újezd jsme brali jako místo, které budeme my i děti nazývat domovem, trávit v něm čas a zvelebovat ho. Díky výborným sousedům byl přechod z města na vesnici příjemně rychlý. Postupně jsme zjišťovali, že k výborným lidem potřebujeme zlepšit i zázemí obce a jeho okolí. Od drobností jakými jsou chodníky, dětská hřiště a silnice bez děr či velkých věcí jako druhý stupeň základní školy nebo centrum obce, kterým se můžeme chlubit svým kamarádům a známým. Chci pomoci Vysokému Újezdu, Kozolupům a Kuchaři v tom, co dělám každý den a čemu rozumím - řízení peněz, projektů, rozpočtování a transparentní vykazování.',
          }}
          perex={
            <p>
              Obec by měla aktivně přistupovat k podpoře rozvoje stávajícího i nově vznikajícího podnikání. Se
              stávajícími podnikateli je nutné zahájit pravidelnou a konkrétní debatu nad tím, jak mohou obci pomoci a
              zároveň, co může obec nabídnout jim. Je zcela běžné, že se firmy zapojují do finanční či věcné podpory
              akcí v obci, kde působí či mají sídlo, stejně jako je běžné, že obec jejich zapojení náležitě propaguje,
              oceňuje a využívá. To platí jak pro větší společnosti, tak pro živnostníky, o kterých mnoho obyvatel ani
              netuší, že je má v sousedství.
            </p>
          }
        >
          <p>
            Obec by měla aktivně přistupovat k podpoře rozvoje stávajícího i nově vznikajícího podnikání. Se stávajícími
            podnikateli je nutné zahájit pravidelnou a konkrétní debatu nad tím, jak mohou obci pomoci a zároveň, co
            může obec nabídnout jim. Je zcela běžné, že se firmy zapojují do finanční či věcné podpory akcí v obci, kde
            působí či mají sídlo, stejně jako je běžné, že obec jejich zapojení náležitě propaguje, oceňuje a využívá.
            To platí jak pro větší společnosti, tak pro živnostníky, o kterých mnoho obyvatel ani netuší, že je má v
            sousedství.
          </p>
          <p>
            V rámci svých možností by měla obec aktivně vytvářet vhodné podmínky pro vznik nového podnikání v oblastech,
            které považuje za důležité pro rozvoj obce a kvalitu života svých obyvatel. Bylo by dobré ve vhodných
            lokalitách umožnit smíšenou výstavbu či výstavbu občanské vybavenosti. Aktivně se snažit, aby zde byly a
            prosperovaly například kavárny, restaurace, lékařská ordinace, sportoviště či místa pro volnočasové
            aktivity. Obec samozřejmě není tím, kdo by podnikání realizoval, ale může vytvořit prostředí, které bude
            podnikatele v daných oblastech motivovat k investici ve Vysokém Újezdu, Kozolupech či Kuchaři…
          </p>
        </Topic>

        <Topic
          color="white"
          subtitle="8. Téma"
          title={
            <>
              Zapojme se <em>společně</em>
            </>
          }
          person={{
            name: 'Mgr. Lenka Matějková',
            photo: '/img/faces/lenka-matejkova.jpg',
            about: 'právník',
            position: 'naše expertka na právní záležitosti',
            quote:
              'Do Vysokého Újezdu jsme se s manželem přestěhovali před pěti lety. Vyhovovala nám blízkost Prahy a dále nám učarovala okolní krajina Českého krasu. V průběhu našeho života ve Vysokém Újezdu se nám narodily dvě holčičky a poznali jsme zde spoustu skvělých lidí. Mně nyní končí rodičovská dovolená a ráda bych část svého času a energie věnovala rozvoji našich obcí. Jako vystudovaná právnička mohu nabídnout orientaci v právním systému České republiky, v případě potřeby též právního systému Evropské unie. Po studiích jsem našla uplatnění v justici, kde jsem se postupně věnovala různým oborům práva, a mohu tedy říci, že jsem ochotna a schopna proniknout do jakékoli právní oblasti. V dnešní době je orientace v právních předpisech nezbytná a v záležitostech veřejné správy obzvlášť. Pojďme společně udělat Vysoký Újezd, Kozolupy a Kuchař ještě krásnějším místem pro život. Místem, kde budou naše děti společně vyrůstat, místem, kde budeme rádi trávit čas my (dospělí v produktivním věku) a v neposlední řádě i místem pro prožití důstojného stáří. Pojďme zde žít společně.',
          }}
          perex={
            <p>
              Ne každý z nás má v našich obcích trvalé bydliště, ať už z důvodu podnikání nebo jen proto, že by rád
              přihlásil své děti do školek a škol v Praze, neboť ty zdejší nemají dostatečnou kapacitu. Lidé, kteří
              nemají v obci trvalé bydliště, však přinášejí minimální příjem do místního rozpočtu, ne-li spíše
              přidružené náklady. Díky obyvatelům, kteří zde nejsou hlášeni k trvalému pobytu, přichází místní rozpočet
              ročně až o 6 milionů Kč. Dle údajů získaných na základě registrace k místním poplatkům se jedná o cca. 40%
              obyvatel bez trvalého bydliště. Rádi bychom pozitivně motivovali obyvatele k přihlášení trvalého pobytu
              například formou různých zvýhodnění nebo možnosti spolupodílet se na diskuzi a rozhodování o plánech a
              projektech v obcích.
            </p>
          }
        >
          <p>
            Ne každý z nás má v našich obcích trvalé bydliště, ať už z důvodu podnikání nebo jen proto, že by rád
            přihlásil své děti do školek a škol v Praze, neboť ty zdejší nemají dostatečnou kapacitu. Lidé, kteří nemají
            v obci trvalé bydliště, však přinášejí minimální příjem do místního rozpočtu, ne-li spíše přidružené
            náklady. Díky obyvatelům, kteří zde nejsou hlášeni k trvalému pobytu, přichází místní rozpočet ročně až o 6
            milionů Kč. Dle údajů získaných na základě registrace k místním poplatkům se jedná o cca. 40% obyvatel bez
            trvalého bydliště. Rádi bychom pozitivně motivovali obyvatele k přihlášení trvalého pobytu například formou
            různých zvýhodnění nebo možnosti spolupodílet se na diskuzi a rozhodování o plánech a projektech v obcích.
          </p>
          <p>
            Většina investic do infrastruktury se neobejde bez spolupráce se Středočeským krajem. Chceme koordinovat
            komunikaci lidí se zastupiteli, orgány Středočeského kraje a s místními médii tak, aby se pomocí vytvořeného
            tlaku dostaly do povědomí požadavky Vysokého Újezdu, Kozolup a Kuchaře a nezapadly mezi tisíce připomínek
            ostatních obcí.
          </p>
          <p>
            Zapojení nás všech do společných projektů je důležité pro komunitní život. Chceme podporovat a zakládat
            finanční sbírky na lokální projekty, organizovat dobrovolné akce zaměřené na úklid obce nebo výsadbu obecní
            zeleně a úpravu našich společných zelených ploch. Námětů na vylepšení našeho společného okolí jistě najde
            každý z nás nespočet. Přejeme si, abyste nám tyto návrhy sdělovali, a budeme také rádi, pokud přiložíte ruku
            k dílu.
          </p>
          <p>Udělejme si to tu hezké, ať se nám tu žije společně dobře.</p>
        </Topic>

        <Topic
          color="light"
          subtitle="9. Téma"
          title={
            <>
              Doprava a bezpečnost <em>společně</em>
            </>
          }
          person={{
            name: 'Eliška Ježková',
            photo: '/img/faces/eliska-jezkova.jpg',
            about: 'projektový manažer ve filmovém průmyslu',
            position: 'náš hlas maminek a spoluorganizátorka dětských akcí',
            quote:
              'Jsem šťastně vdaná maminka 3 letého syna a pocházím z Prahy. Jako projektový manažer jsem měla a mám možnost pracovat s mnoha klienty z velkých i malých firem. Nebojím se nových výzev a projekty dotahuji vždy do konce. Moje rodina je pro mě na prvním místě. Krása tohoto místa a lidí mě uchvátila. Nikdy si nepřestanu vážit toho, že má moje rodina takové štěstí zde žít. Přála bych si, aby se naše obce staly místem, kde vychováme děti ke slušnosti, pokoře, respektu a v bezpečí a kde jim dáme takové dětství, na které budou v dobrém vzpomínat celý život. Cítím, že právě zde je to pravé místo.',
          }}
          perex={
            <p>
              Každý den ráno potřebujeme naše děti odvézt do škol a školek a poté se dopravit do práce. Odpoledne se vše
              opakuje a přibývá ještě rozvážení dětí do kroužků a na tréninky. Večer bychom eventuálně rádi vyrazili za
              zábavou do Prahy. Nedostatečná frekvence veřejné dopravy a chybějící spoje nás nutí každý den používat
              individuální dopravní prostředky a doslova z nás dělají taxikáře. Naše obce leží zhruba 10 km od Prahy či
              Berouna, a však při stávající dopravní infrastruktuře je i přes rostoucí cenu pohonných hmot pro většinu
              obyvatel nemožné využívat hromadnou dopravu. Zbytečná ztráta času za volantem v ranních i odpoledních
              špičkách nikoho netěší, nicméně zatím není mnoho jiných variant.
            </p>
          }
        >
          <p>
            Každý den ráno potřebujeme naše děti odvézt do škol a školek a poté se dopravit do práce. Odpoledne se vše
            opakuje a přibývá ještě rozvážení dětí do kroužků a na tréninky. Večer bychom eventuálně rádi vyrazili za
            zábavou do Prahy. Nedostatečná frekvence veřejné dopravy a chybějící spoje nás nutí každý den používat
            individuální dopravní prostředky a doslova z nás dělají taxikáře. Naše obce leží zhruba 10 km od Prahy či
            Berouna, a však při stávající dopravní infrastruktuře je i přes rostoucí cenu pohonných hmot pro většinu
            obyvatel nemožné využívat hromadnou dopravu. Zbytečná ztráta času za volantem v ranních i odpoledních
            špičkách nikoho netěší, nicméně zatím není mnoho jiných variant.
          </p>
          <p>
            Naším cílem je nejen lépe propojit naše obce vybudováním cyklostezek, posílením veřejné dopravy jak mezi
            našimi obcemi navzájem, tak i s Berounem a Prahou, ale i oprava stávajících komunikací. Dále chceme podpořit
            multimodální dopravu (kombinace více druhů dopravy - cyklo, bus, vlak, metro), zvýšit využívání vlakového
            spojení posílením časově navazujících autobusových spojů na zastávku v Nučicích a také propojit Vysoký Újezd
            se stanicí Mezouň vybudováním cyklostezky určené i pro pěší. Chceme též vstoupit do jednání se Středočeským
            krajem a Ropidem (Pražská integrovaná doprava) a docílit toho, aby některé autobusové spoje měly
            “dálkovější” charakter (tedy přímý spoj Rudná - metro Zličín).
          </p>
          <p>
            Zároveň se zaměříme na bezpečnost pohybu po našich obcích. Bohužel současný stav našich místních komunikací
            a chybějící chodníky bezpečnosti nenahrávají. Navrhujeme vypracovat bezpečnostně dopravní studii, která
            identifikuje riziková místa, stanoví priority a navrhne opatření, která budeme postupně realizovat. Studie
            by koncepčně řešila budoucí komunikace, chodníky, přechody, cyklostezky, obytné a pěší zóny, parkování i
            veřejné osvětlení.
          </p>
          <p>
            Obecně je nutné snížit a zpomalit průjezd všemi našimi obcemi. Z dlouhodobého pohledu nám k tomu pomůže
            realizace obchvatů obcí a převedení současných průjezdných krajských komunikací na místní obslužné.
          </p>
        </Topic>

        <VoteUs />

        <div>
          <p className="p-6 text-center text-xs text-neutral-600">
            Pro <strong>ŽIJME SPOLEČNĚ, sdružení nezávislých kandidátů</strong> vytvořilo studio{' '}
            <a href="https://www.elasticle.cz" className="text-blue-900 font-bold">
              Elasticle
            </a>
            , {new Date().getFullYear()}.
          </p>
        </div>
      </div>
    </>
  );
}

export default Site;
